import InitialDetails from './InitialDetails'

export default InitialDetails
